import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$namesFooter = new Vue({
  methods: {
    getData() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`${getBaseUrl()}names`)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
